(() => {
    const producCardtList = document.querySelectorAll('.product-card');
    producCardtList.forEach(productCard => {
        const productLinks = productCard.querySelectorAll('a[href*="/products/"]');
        const bssLockElement = productCard.querySelector('.bss-lock-element');
        if (bssLockElement) {
            productLinks.forEach(productLink => {
                productLink.href = '/pages/trade-registration'
            })
        }
        console.log(productCard)
    });
})()